var extendFlags,
  indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

extendFlags = function() {
  var bodyClasses, ref, ref1;
  bodyClasses = document.body.classList || $(document.body).getClasses();
  return _.extend(window.Groupon, {
    App: {
      name: $(document.head).attr('data-app')
    },
    Browsers: {
      chrome: !!window.chrome,
      ltIE10: $('html').hasClass('lt-ie10'),
      phantomJS: !!(window._phantom || window.callPhantom),
      safari: ((ref = navigator.vendor) != null ? ref.indexOf('Apple') : void 0) > -1 && !((ref1 = navigator.userAgent) != null ? ref1.match('CriOS') : void 0)
    },
    PageFlags: {
      isWeb: indexOf.call(bodyClasses, 'is-web') >= 0,
      isTouch: indexOf.call(bodyClasses, 'is-touch') >= 0,
      isLegacyResponsive: indexOf.call(bodyClasses, 'ls-resp') >= 0,
      isTouchRedesign: indexOf.call(bodyClasses, 't-redesign') >= 0,
      isTouchRequest: indexOf.call(bodyClasses, 'is-touch-request') >= 0
    }
  });
};

module.exports = function() {
  if (document.body != null) {
    return extendFlags();
  } else {
    return $(function() {
      return extendFlags();
    });
  }
};

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL2dyb3Vwb25fZXh0ZW5kZWQuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL1VzZXJzL3NraW0vc2xzL2NvcmUvZnJvbnRlbmQvZ3JvdXBvbl9tb2R1bGVzL2dyb3Vwb25fZXh0ZW5kZWQuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsV0FBQTtFQUFBOztBQUFBLFdBQUEsR0FBYyxTQUFBO0FBRVosTUFBQTtFQUFBLFdBQUEsR0FBYyxRQUFRLENBQUMsSUFBSSxDQUFDLFNBQWQsSUFBMkIsQ0FBQSxDQUFFLFFBQVEsQ0FBQyxJQUFYLENBQWdCLENBQUMsVUFBakIsQ0FBQTtTQUV6QyxDQUFDLENBQUMsTUFBRixDQUFTLE1BQU0sQ0FBQyxPQUFoQixFQUF5QjtJQUN2QixHQUFBLEVBQ0U7TUFBQSxJQUFBLEVBQU0sQ0FBQSxDQUFFLFFBQVEsQ0FBQyxJQUFYLENBQWdCLENBQUMsSUFBakIsQ0FBc0IsVUFBdEIsQ0FBTjtLQUZxQjtJQUd2QixRQUFBLEVBQ0U7TUFBQSxNQUFBLEVBQVEsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxNQUFqQjtNQUNBLE1BQUEsRUFBUSxDQUFBLENBQUUsTUFBRixDQUFTLENBQUMsUUFBVixDQUFtQixTQUFuQixDQURSO01BRUEsU0FBQSxFQUFXLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxRQUFQLElBQW1CLE1BQU0sQ0FBQyxXQUEzQixDQUZiO01BR0EsTUFBQSx5Q0FBd0IsQ0FBRSxPQUFsQixDQUEwQixPQUExQixXQUFBLEdBQXFDLENBQUMsQ0FBdEMsSUFBNEMsNkNBQXVCLENBQUUsS0FBckIsQ0FBMkIsT0FBM0IsV0FIeEQ7S0FKcUI7SUFRdkIsU0FBQSxFQUNFO01BQUEsS0FBQSxFQUFPLGFBQVksV0FBWixFQUFBLFFBQUEsTUFBUDtNQUNBLE9BQUEsRUFBUyxhQUFjLFdBQWQsRUFBQSxVQUFBLE1BRFQ7TUFFQSxrQkFBQSxFQUFvQixhQUFhLFdBQWIsRUFBQSxTQUFBLE1BRnBCO01BR0EsZUFBQSxFQUFpQixhQUFnQixXQUFoQixFQUFBLFlBQUEsTUFIakI7TUFJQSxjQUFBLEVBQWdCLGFBQXNCLFdBQXRCLEVBQUEsa0JBQUEsTUFKaEI7S0FUcUI7R0FBekI7QUFKWTs7QUFvQmQsTUFBTSxDQUFDLE9BQVAsR0FBaUIsU0FBQTtFQUNmLElBQUcscUJBQUg7V0FDRSxXQUFBLENBQUEsRUFERjtHQUFBLE1BQUE7V0FHRSxDQUFBLENBQUUsU0FBQTthQUFHLFdBQUEsQ0FBQTtJQUFILENBQUYsRUFIRjs7QUFEZSJ9
